export const zeroDigit = (num) =>
  num.toString().length === 1 ? `0${num}` : num;

export const capitalize = (txt) =>
  `${txt.charAt(0).toUpperCase()}${txt.slice(1)}`;
